export const timeZones = [
  {
    displayName: '(GMT+00:00) UTC',
    value: 'UTC',
  },
  {
    displayName: '(GMT-12:00) International Date Line West',
    value: 'International Date Line West',
  },
  {
    displayName: '(GMT-11:00) Midway Island',
    value: 'Midway Island',
  },
  {
    displayName: '(GMT-11:00) American Samoa',
    value: 'American Samoa',
  },
  {
    displayName: '(GMT-10:00) Hawaii',
    value: 'Hawaii',
  },
  {
    displayName: '(GMT-09:00) Alaska',
    value: 'Alaska',
  },
  {
    displayName: '(GMT-08:00) Pacific Time (US & Canada)',
    value: 'Pacific Time (US & Canada)',
  },
  {
    displayName: '(GMT-08:00) Tijuana',
    value: 'Tijuana',
  },
  {
    displayName: '(GMT-07:00) Arizona',
    value: 'Arizona',
  },
  {
    displayName: '(GMT-07:00) Chihuahua',
    value: 'Chihuahua',
  },
  {
    displayName: '(GMT-07:00) Mazatlan',
    value: 'Mazatlan',
  },
  {
    displayName: '(GMT-07:00) Mountain Time (US & Canada)',
    value: 'Mountain Time (US & Canada)',
  },
  {
    displayName: '(GMT-06:00) Mexico City',
    value: 'Mexico City',
  },
  {
    displayName: '(GMT-06:00) Central America',
    value: 'Central America',
  },
  {
    displayName: '(GMT-06:00) Central Time (US & Canada)',
    value: 'Central Time (US & Canada)',
  },
  {
    displayName: '(GMT-06:00) Guadalajara',
    value: 'Guadalajara',
  },
  {
    displayName: '(GMT-06:00) Monterrey',
    value: 'Monterrey',
  },
  {
    displayName: '(GMT-06:00) Saskatchewan',
    value: 'Saskatchewan',
  },
  {
    displayName: '(GMT-05:00) Bogota',
    value: 'Bogota',
  },
  {
    displayName: '(GMT-05:00) Indiana (East)',
    value: 'Indiana (East)',
  },
  {
    displayName: '(GMT-05:00) Lima',
    value: 'Lima',
  },
  {
    displayName: '(GMT-05:00) Quito',
    value: 'Quito',
  },
  {
    displayName: '(GMT-05:00) Eastern Time (US & Canada)',
    value: 'Eastern Time (US & Canada)',
  },
  {
    displayName: '(GMT-04:00) Santiago',
    value: 'Santiago',
  },
  {
    displayName: '(GMT-04:00) Caracas',
    value: 'Caracas',
  },
  {
    displayName: '(GMT-04:00) Atlantic Time (Canada)',
    value: 'Atlantic Time (Canada)',
  },
  {
    displayName: '(GMT-04:00) Georgetown',
    value: 'Georgetown',
  },
  {
    displayName: '(GMT-04:00) La Paz',
    value: 'La Paz',
  },
  {
    displayName: '(GMT-04:00) Puerto Rico',
    value: 'Puerto Rico',
  },
  {
    displayName: '(GMT-03:30) Newfoundland',
    value: 'Newfoundland',
  },
  {
    displayName: '(GMT-03:00) Greenland',
    value: 'Greenland',
  },
  {
    displayName: '(GMT-03:00) Brasilia',
    value: 'Brasilia',
  },
  {
    displayName: '(GMT-03:00) Buenos Aires',
    value: 'Buenos Aires',
  },
  {
    displayName: '(GMT-03:00) Montevideo',
    value: 'Montevideo',
  },
  {
    displayName: '(GMT-02:00) Mid-Atlantic',
    value: 'Mid-Atlantic',
  },
  {
    displayName: '(GMT-01:00) Azores',
    value: 'Azores',
  },
  {
    displayName: '(GMT-01:00) Cape Verde Is.',
    value: 'Cape Verde Is.',
  },
  {
    displayName: '(GMT+00:00) Monrovia',
    value: 'Monrovia',
  },
  {
    displayName: '(GMT+00:00) Edinburgh',
    value: 'Edinburgh',
  },
  {
    displayName: '(GMT+00:00) Lisbon',
    value: 'Lisbon',
  },
  {
    displayName: '(GMT+00:00) Casablanca',
    value: 'Casablanca',
  },
  {
    displayName: '(GMT+00:00) Dublin',
    value: 'Dublin',
  },
  {
    displayName: '(GMT+00:00) London',
    value: 'London',
  },
  {
    displayName: '(GMT+01:00) Ljubljana',
    value: 'Ljubljana',
  },
  {
    displayName: '(GMT+01:00) Madrid',
    value: 'Madrid',
  },
  {
    displayName: '(GMT+01:00) Paris',
    value: 'Paris',
  },
  {
    displayName: '(GMT+01:00) Prague',
    value: 'Prague',
  },
  {
    displayName: '(GMT+01:00) Rome',
    value: 'Rome',
  },
  {
    displayName: '(GMT+01:00) Sarajevo',
    value: 'Sarajevo',
  },
  {
    displayName: '(GMT+01:00) Skopje',
    value: 'Skopje',
  },
  {
    displayName: '(GMT+01:00) Stockholm',
    value: 'Stockholm',
  },
  {
    displayName: '(GMT+01:00) Vienna',
    value: 'Vienna',
  },
  {
    displayName: '(GMT+01:00) Warsaw',
    value: 'Warsaw',
  },
  {
    displayName: '(GMT+01:00) West Central Africa',
    value: 'West Central Africa',
  },
  {
    displayName: '(GMT+01:00) Zagreb',
    value: 'Zagreb',
  },
  {
    displayName: '(GMT+01:00) Zurich',
    value: 'Zurich',
  },
  {
    displayName: '(GMT+01:00) Amsterdam',
    value: 'Amsterdam',
  },
  {
    displayName: '(GMT+01:00) Belgrade',
    value: 'Belgrade',
  },
  {
    displayName: '(GMT+01:00) Berlin',
    value: 'Berlin',
  },
  {
    displayName: '(GMT+01:00) Bern',
    value: 'Bern',
  },
  {
    displayName: '(GMT+01:00) Bratislava',
    value: 'Bratislava',
  },
  {
    displayName: '(GMT+01:00) Brussels',
    value: 'Brussels',
  },
  {
    displayName: '(GMT+01:00) Budapest',
    value: 'Budapest',
  },
  {
    displayName: '(GMT+01:00) Copenhagen',
    value: 'Copenhagen',
  },
  {
    displayName: '(GMT+02:00) Tallinn',
    value: 'Tallinn',
  },
  {
    displayName: '(GMT+02:00) Athens',
    value: 'Athens',
  },
  {
    displayName: '(GMT+02:00) Bucharest',
    value: 'Bucharest',
  },
  {
    displayName: '(GMT+02:00) Cairo',
    value: 'Cairo',
  },
  {
    displayName: '(GMT+02:00) Harare',
    value: 'Harare',
  },
  {
    displayName: '(GMT+02:00) Helsinki',
    value: 'Helsinki',
  },
  {
    displayName: '(GMT+02:00) Jerusalem',
    value: 'Jerusalem',
  },
  {
    displayName: '(GMT+02:00) Kaliningrad',
    value: 'Kaliningrad',
  },
  {
    displayName: '(GMT+02:00) Kyiv',
    value: 'Kyiv',
  },
  {
    displayName: '(GMT+02:00) Pretoria',
    value: 'Pretoria',
  },
  {
    displayName: '(GMT+02:00) Riga',
    value: 'Riga',
  },
  {
    displayName: '(GMT+02:00) Sofia',
    value: 'Sofia',
  },
  {
    displayName: '(GMT+02:00) Vilnius',
    value: 'Vilnius',
  },
  {
    displayName: '(GMT+03:00) Istanbul',
    value: 'Istanbul',
  },
  {
    displayName: '(GMT+03:00) Kuwait',
    value: 'Kuwait',
  },
  {
    displayName: '(GMT+03:00) Minsk',
    value: 'Minsk',
  },
  {
    displayName: '(GMT+03:00) Moscow',
    value: 'Moscow',
  },
  {
    displayName: '(GMT+03:00) Baghdad',
    value: 'Baghdad',
  },
  {
    displayName: '(GMT+03:00) Nairobi',
    value: 'Nairobi',
  },
  {
    displayName: '(GMT+03:00) Riyadh',
    value: 'Riyadh',
  },
  {
    displayName: '(GMT+03:00) St. Petersburg',
    value: 'St. Petersburg',
  },
  {
    displayName: '(GMT+03:00) Volgograd',
    value: 'Volgograd',
  },
  {
    displayName: '(GMT+03:30) Tehran',
    value: 'Tehran',
  },
  {
    displayName: '(GMT+04:00) Abu Dhabi',
    value: 'Abu Dhabi',
  },
  {
    displayName: '(GMT+04:00) Baku',
    value: 'Baku',
  },
  {
    displayName: '(GMT+04:00) Muscat',
    value: 'Muscat',
  },
  {
    displayName: '(GMT+04:00) Samara',
    value: 'Samara',
  },
  {
    displayName: '(GMT+04:00) Tbilisi',
    value: 'Tbilisi',
  },
  {
    displayName: '(GMT+04:00) Yerevan',
    value: 'Yerevan',
  },
  {
    displayName: '(GMT+04:30) Kabul',
    value: 'Kabul',
  },
  {
    displayName: '(GMT+05:00) Ekaterinburg',
    value: 'Ekaterinburg',
  },
  {
    displayName: '(GMT+05:00) Islamabad',
    value: 'Islamabad',
  },
  {
    displayName: '(GMT+05:00) Karachi',
    value: 'Karachi',
  },
  {
    displayName: '(GMT+05:00) Tashkent',
    value: 'Tashkent',
  },
  {
    displayName: '(GMT+05:30) Chennai',
    value: 'Chennai',
  },
  {
    displayName: '(GMT+05:30) Kolkata',
    value: 'Kolkata',
  },
  {
    displayName: '(GMT+05:30) Mumbai',
    value: 'Mumbai',
  },
  {
    displayName: '(GMT+05:30) New Delhi',
    value: 'New Delhi',
  },
  {
    displayName: '(GMT+05:30) Sri Jayawardenepura',
    value: 'Sri Jayawardenepura',
  },
  {
    displayName: '(GMT+05:45) Kathmandu',
    value: 'Kathmandu',
  },
  {
    displayName: '(GMT+06:00) Almaty',
    value: 'Almaty',
  },
  {
    displayName: '(GMT+06:00) Astana',
    value: 'Astana',
  },
  {
    displayName: '(GMT+06:00) Dhaka',
    value: 'Dhaka',
  },
  {
    displayName: '(GMT+06:00) Urumqi',
    value: 'Urumqi',
  },
  {
    displayName: '(GMT+06:30) Rangoon',
    value: 'Rangoon',
  },
  {
    displayName: '(GMT+07:00) Novosibirsk',
    value: 'Novosibirsk',
  },
  {
    displayName: '(GMT+07:00) Bangkok',
    value: 'Bangkok',
  },
  {
    displayName: '(GMT+07:00) Hanoi',
    value: 'Hanoi',
  },
  {
    displayName: '(GMT+07:00) Jakarta',
    value: 'Jakarta',
  },
  {
    displayName: '(GMT+07:00) Krasnoyarsk',
    value: 'Krasnoyarsk',
  },
  {
    displayName: '(GMT+08:00) Chongqing',
    value: 'Chongqing',
  },
  {
    displayName: '(GMT+08:00) Hong Kong',
    value: 'Hong Kong',
  },
  {
    displayName: '(GMT+08:00) Irkutsk',
    value: 'Irkutsk',
  },
  {
    displayName: '(GMT+08:00) Beijing',
    value: 'Beijing',
  },
  {
    displayName: '(GMT+08:00) Kuala Lumpur',
    value: 'Kuala Lumpur',
  },
  {
    displayName: '(GMT+08:00) Perth',
    value: 'Perth',
  },
  {
    displayName: '(GMT+08:00) Taipei',
    value: 'Taipei',
  },
  {
    displayName: '(GMT+08:00) Ulaanbaatar',
    value: 'Ulaanbaatar',
  },
  {
    displayName: '(GMT+09:00) Osaka',
    value: 'Osaka',
  },
  {
    displayName: '(GMT+09:00) Sapporo',
    value: 'Sapporo',
  },
  {
    displayName: '(GMT+09:00) Seoul',
    value: 'Seoul',
  },
  {
    displayName: '(GMT+09:00) Tokyo',
    value: 'Tokyo',
  },
  {
    displayName: '(GMT+09:00) Yakutsk',
    value: 'Yakutsk',
  },
  {
    displayName: '(GMT+09:30) Adelaide',
    value: 'Adelaide',
  },
  {
    displayName: '(GMT+09:30) Darwin',
    value: 'Darwin',
  },
  {
    displayName: '(GMT+10:00) Hobart',
    value: 'Hobart',
  },
  {
    displayName: '(GMT+10:00) Brisbane',
    value: 'Brisbane',
  },
  {
    displayName: '(GMT+10:00) Canberra',
    value: 'Canberra',
  },
  {
    displayName: '(GMT+10:00) Guam',
    value: 'Guam',
  },
  {
    displayName: '(GMT+10:00) Melbourne',
    value: 'Melbourne',
  },
  {
    displayName: '(GMT+10:00) Port Moresby',
    value: 'Port Moresby',
  },
  {
    displayName: '(GMT+10:00) Sydney',
    value: 'Sydney',
  },
  {
    displayName: '(GMT+10:00) Vladivostok',
    value: 'Vladivostok',
  },
  {
    displayName: '(GMT+11:00) Solomon Is.',
    value: 'Solomon Is.',
  },
  {
    displayName: '(GMT+11:00) Magadan',
    value: 'Magadan',
  },
  {
    displayName: '(GMT+11:00) Srednekolymsk',
    value: 'Srednekolymsk',
  },
  {
    displayName: '(GMT+11:00) New Caledonia',
    value: 'New Caledonia',
  },
  {
    displayName: '(GMT+12:00) Wellington',
    value: 'Wellington',
  },
  {
    displayName: '(GMT+12:00) Kamchatka',
    value: 'Kamchatka',
  },
  {
    displayName: '(GMT+12:00) Auckland',
    value: 'Auckland',
  },
  {
    displayName: '(GMT+12:00) Fiji',
    value: 'Fiji',
  },
  {
    displayName: '(GMT+12:00) Marshall Is.',
    value: 'Marshall Is.',
  },
  {
    displayName: '(GMT+12:45) Chatham Is.',
    value: 'Chatham Is.',
  },
  {
    displayName: "(GMT+13:00) Nuku'alofa",
    value: "Nuku'alofa",
  },
  {
    displayName: '(GMT+13:00) Samoa',
    value: 'Samoa',
  },
  {
    displayName: '(GMT+13:00) Tokelau Is.',
    value: 'Tokelau Is.',
  },
];
